import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../context/TranslationContext';
import '../styles/NotFound.css';
import Breadcrumb from './Breadcrumb';

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="notfound-container">
      <Breadcrumb
          items={[
              { label: t('breadcrumb.home'), link: '/' },
              { label: t('breadcrumb.notFound')}
          ]}
      />
      <h1 className="notfound-title">{t('notFound.notFoundTitle')}</h1>
      <p className="notfound-message">{t('notFound.notFoundMessage')}</p>
      <button className="notfound-button" onClick={() => navigate('/')}>
        {t('notFound.notFoundButton')}
      </button>
    </div>
  );
};

export default NotFound;
